import axios from './axios';

export const acceptTermsAndConditions = async () => {
  await axios.get('/api/User/AcceptTermsAndConditions');
};
